export default __webpack_public_path__ + "static/media/explore2.224e3f38.png";